/// <amd-module name="Search/Code/Flux/Stores/PreviewOrientationStore" />
import * as Resources from "Search/Shared/Resources";
import { PreviewOrientationStore as BasePreviewOrientationStore } from "Search/Shared/Base/Stores/PreviewOrientationStore";
import { PreviewOrientationActionIds, PreferenceConstants } from "Search/Code/Constants";
import { IPreviewSetting } from "Search/Shared/Base/Types";
import { IVssPageContext } from "VSS/Platform/Context";

export class PreviewOrientationStore extends BasePreviewOrientationStore {
    constructor(changeEventName: string, pageContext: IVssPageContext) {
        super(
            changeEventName,
            pageContext,
            PreferenceConstants.PreviewOrientationKey,
            PreferenceConstants.SplitterFixedSizeKey,
            PreviewOrientationActionIds.Right
        );
    }

    public get availablePreviewOrientations(): IPreviewSetting[] {
        return [
            { key: PreviewOrientationActionIds.Right, name: Resources.RightPreviewOrientation },
            { key: PreviewOrientationActionIds.Bottom, name: Resources.BottomPreviewOrientation }
        ];
    }
}